import script from "./Background.vue?vue&type=script&setup=true&lang=ts"
export * from "./Background.vue?vue&type=script&setup=true&lang=ts"

import "./Background.vue?vue&type=style&index=0&id=2d4b7841&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d4b7841"]])

export default __exports__